import { render, staticRenderFns } from "./team-agent.vue?vue&type=template&id=49b2a2bb&scoped=true"
import script from "./team-agent.vue?vue&type=script&lang=js"
export * from "./team-agent.vue?vue&type=script&lang=js"
import style0 from "./team-agent.vue?vue&type=style&index=0&id=49b2a2bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b2a2bb",
  null
  
)

export default component.exports